import {AnalysisGraphQL, AnalysisViewGraphQL} from 'analysis-tool/AnalysisTypes';
import getAdditionalDataFrameMetadataModalContent from 'analysis-tool/data-frame-metadata/getDataFrameMetadataModalContent';
import {isTopLevelDataFrameView} from 'analysis-tool/data-view/AnalysisViewUtils';
import {DataViewContextValue} from 'analysis-tool/data-view/DataViewContext';

export default function getAdditionalMetadataContent(
  analysis: AnalysisGraphQL,
  view: AnalysisViewGraphQL
): DataViewContextValue['additionalMetadataContent'] {
  if (isTopLevelDataFrameView(view)) {
    // The additional details are only relevant for top-level tables
    return getAdditionalDataFrameMetadataModalContent(
      analysis.steps.find(({id}) => id === view.lineage[0].step.id)!
    );
  }

  return undefined;
}
